import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from "gatsby";
import "../styles/bootstrap.min.css";
import '../styles/fonts.css';
import '../styles/common.scss';
import '../styles/stylesheet.scss';

import { LanguagesContext } from '../context/languages';

import { Loader } from '../components';

export const Layout = ({ children }) => {
    let [languages, setLanguages] = useState({});
    let [ready, setReady] = useState(false);

    const data = useStaticQuery(pageQuery);

    useEffect(() => {
        if (data && data?.site?.siteMetadata?.languages) {
            setLanguages(data.site.siteMetadata.languages);
        }
        setReady(true);

        if(typeof window !== "undefined"){
            setTimeout(() => {
                // let's delay for better page performance, we don't need it right away
                window.__lc = window.__lc || {};
                window.__lc.license = 7519271;
                var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
                lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
            }, 10000);
            
        }

    }, []);

    if (ready) {
        return (
            <LanguagesContext.Provider value={languages}>
                <>{children}</>
            </LanguagesContext.Provider>
        )
    } else {
        return <Loader />;
    }
};


const pageQuery = graphql`  
query SearchQuery {
    site {
      siteMetadata {
        languages {
          defaultLangKey
          langs
          languages_info{
            id
            code
            name
          }
        }
      }
    }    
}`;
